import { AxiosInstance } from 'axios'

export function setupApiStackTraceInterceptors(instance: AxiosInstance): AxiosInstance {
    instance.interceptors.request.use(
        (config) => {
            ;(config as any).__callerStack = new Error().stack
            return config
        },
        undefined,
        { synchronous: true },
    )

    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            const callerStack = error?.config?.__callerStack
            if (error instanceof Error && callerStack) {
                error.stack = (error.stack ?? '') + '\nCaller:\n' + callerStack
            }
            return Promise.reject(error)
        },
    )

    return instance
}
